import { GameClubDescriptionWrapper } from "../../../Style/GameClubMyStyles";

export default function GameClubDescription({
  description,
}: {
  description: string;
}) {
  return <GameClubDescriptionWrapper>{description}</GameClubDescriptionWrapper>;
}
